import React, { FC } from "react";

import { CategoryCard } from "@/components/molecules";
import { ContractCategory } from "@/shared/domain";

import { ContractCategoryIcon } from "../ContractCategoryIcon/ContractCategoryIcon";

type ContractCategoryItemProps = {
    contractCategory?: ContractCategory;
    onCategoryClick: () => void;
};

const ContractCategoryItem: FC<ContractCategoryItemProps> = ({ contractCategory, onCategoryClick }) => {
    return (
        <CategoryCard
            id={contractCategory.category.id}
            name={contractCategory.category.name}
            icon={<ContractCategoryIcon categoryId={contractCategory.category.id} />}
            count={contractCategory.totalItems}
            testPrefix="contract_category_item-card"
            onClick={onCategoryClick}
        />
    );
};

export default ContractCategoryItem;
